import { getEventActionName } from "../../core/make-action";
import ViewerEvent from "../../core/ViewerEvent";
import { LocationEventData, LocationState } from "./types";

const initialState: LocationState = {
  locations: [],
  dimensions: {
    width: 0,
    height: 0,
    offsetTop: 0,
    offsetLeft: 0,
  },
};

export default function (state = initialState, action): LocationState {
  switch (action.type) {
    case getEventActionName(ViewerEvent.LOCATION_UPDATE):
      const eventData = action.eventData as LocationEventData;
      const correctedLocations = eventData.locations
        // Remove unknown/invalid locations
        .filter((item) => item.position.y >= 0)
        // Put in visual order
        .sort((a, b) => {
          const yDiff = a!.position.y - b!.position.y;
          if (yDiff === 0) {
            return a!.position.x - b!.position.x;
          }
          return yDiff;
        })
        // Make shape a bit nicer to work with
        .map((item) => ({
          data: item.location.metadata.data,
          type: item.location.metadata.type,
          position: item.position,
        }));

      return {
        dimensions: action.eventData.dimensions,
        locations: correctedLocations,
      };
    default:
      return state;
  }
}
